import yn from 'yn'

const shouldDisableCrossing = (
  crossing,
  activeVehicleResourceCode,
  activeVehicle
) => {
  const { formattedResources } = crossing
  const crossingVehicles = formattedResources?.vehicles || []

  const filteredVehicles = activeVehicleResourceCode
    ? crossingVehicles.filter(
        vehicle => vehicle.resourceCode === activeVehicleResourceCode
      )
    : crossingVehicles

  const vehiclesAvailable = filteredVehicles.some(vehicle => {
    return activeVehicle?.vehicleLength
      ? +vehicle.freeCapacity >= +activeVehicle?.vehicleLength
      : vehicle.freeCapacity > 0
  })

  return (
    yn(crossing.isICLocked) ||
    (crossing.minutesToDeparture !== undefined &&
      crossing.minutesToDeparture < 90) ||
    (activeVehicleResourceCode && !vehiclesAvailable)
  )
}

export default shouldDisableCrossing
